import {usePyConfig} from "@/api/usePyConfig";
import axios from "@/utils/axios";
import qs from "qs";
import {baseURL} from "@/main";


/**
 * 邮件群发任务列表
 * @returns {Promise<DefaultResponseType>}
 */
export const mailList = (query) => {
    const config = usePyConfig(
        "GET",
        "api/pandagpt/v1/mail/list",
        query
    )
    return axios(...Object.values(config))
}


/**
 * 新建邮件群发
 * @returns {Promise<DefaultResponseType>}
 */
export const mailCreate = (query) => {
    const config = usePyConfig("POST", "api/pandagpt/v1/mail/create", query);
    return axios(...Object.values(config))
}

/**
 * 邮件群发-确认群发任务
 * @param {FormData} formData
 */
export const mailTaskConfirmation = (formData) => {
    const config = usePyConfig("POST", "api/pandagpt/v1/mail/task_confirmation", formData);
    return axios(...Object.values(config));
}


/**
 * 邮件群发-取消任务
 * @param task_id
 * @returns {Promise<DefaultResponseType>}
 */
export const mailMissionCancel = (task_id) => {
    const config = usePyConfig("POST", "api/pandagpt/v1/mail/delete", {task_id});
    return axios(...Object.values(config));
}

/**
 * 邮件群发-数据指标
 * @param task_id
 * @returns {Promise<DefaultResponseType>}
 */
export const mailDataIndex = (task_id) => {
    const config = usePyConfig("get", "api/pandagpt/v1/mail/data_index", {task_id});
    return axios(...Object.values(config));
}

/**
 * 邮件群发-邮件发送记录
 * @param params
 */
export const mailRecord = (params) => {
    const config = usePyConfig("get", "api/pandagpt/v1/mail/mail_record", params);
    return axios(...Object.values(config));
}

/**
 * 邮件群发-邮件附件上传
 * @param {File} file
 * @returns {Promise<DefaultResponseType>}
 */
export const mailFileUpload = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const config = usePyConfig("POST", "api/pandagpt/v1/mail/file_upload", formData);
    return axios(...Object.values(config));
}

/**
 * 邮件群发-任务详情
 * @returns {Promise<DefaultResponseType>}
 */
export const mailDetail = (query) => {
    const config = usePyConfig("GET", "api/pandagpt/v1/mail/detail", query);
    return axios(...Object.values(config));
}

/**
 * 导出邮件发送记录
 * @param {Record<string,any>} searchData
 */
export const mailExportRecord = (searchData) => {
    const params = qs.stringify(searchData);
    const link = `${baseURL.$PyHost}api/pandagpt/v1/mail/export_record?${params}`
    window.open(link, "_blank");
}

/** 文件图标映射 */
export const fileTypeIconMap = new Map([
    ["doc", "DOC"],
    ["docx", "DOC"],
    ["xls", "Excel"],
    ["xlsx", "Excel"],
    ["csv", "Excel"],
    ["ppt", "PPT"],
    ["pptx", "PPT"],
    ["jpg", "IMG"],
    ["jpeg", "IMG"],
    ["png", "IMG"],
    ["gif", "IMG"],
    ["webp", "IMG"],
    ["svg", "IMG"],
    ["mp4", "WAV"],
    ["mov", "WAV"],
    ["mp3", "WAV"],
    ["wav", "WAV"],
    ["zip", "ZIP"],
    ["rar", "ZIP"],
    ["7z", "ZIP"],
    ["tar", "ZIP"],
    ["gz", "ZIP"],
    ["pdf", "PDF"]
])